

module.exports = __webpack_require__.stylable.create(
    "Widget3300798830",
    {"classes":{"root":"Widget3300798830__root","header":"Widget3300798830__header","disclaimer":"Widget3300798830__disclaimer"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Widget3300798830",
    null
);
